import { Component, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-nepalautomative-market-study',
  templateUrl: './nepalautomative-market-study.component.html',
  styleUrls: ['./nepalautomative-market-study.component.css']
})

export class NepalautomativeMarketStudyComponent implements OnInit {

  isLoader = false
  body = true
  Output:any = " "
  space = " "

  constructor(private service:ServiceService, private route:ActivatedRoute, private router:Router ) { }

  //excel Export For CustomerKyc
  excelExport() {
    var orderTable = document.getElementById('MarketStudy');
    var wb = XLSX.utils.table_to_book(orderTable, { sheet: "sheet1" });

    return XLSX.writeFile(wb, ('Nepal Automotive Market Study.' + ('xlsx')));


  }

  ngOnInit(): void {
    this.service.viewnepalautomotivemarketstudy().subscribe((res)=>{
      this.Output = res.data
      console.log("data==", Output);
      
    })
  }

}
